/**
 * SILWER: forward UTM parameters to internal links (v1)
 * ------------------------------------------------------
 * A visitor who lands with utm_* parameters keeps them on the next page
 * they open on this site, the same way the explore-collections section
 * already does with its own links.
 *
 * WHAT IT DOES
 * - Runs only when the current page URL has utm_* parameters.
 * - Adds those utm_* parameters to a same-site link at the moment it is
 *   clicked, middle-clicked or right-clicked (so links added later by
 *   carousels, drawers or search are covered too).
 * - Leaves a link alone if it already carries its own utm_* tags, and
 *   keeps every other parameter on the link exactly as written.
 *
 * WHAT IT NEVER TOUCHES
 * - Cart, checkout, account, app-proxy, policy and password links.
 * - Same-page anchors (#...), mailto/tel links, downloads, other domains.
 * - Cookies, localStorage, sessionStorage, cart attributes, GoKwik,
 *   PostHog, GTM, GA4 or Meta. First-touch attribution in theme.liquid
 *   is unaffected (it keeps the first visit's values for 30 days).
 * - Click IDs (gclid, fbclid): those already live in their own cookies.
 *
 * Fails silently on any error; never blocks navigation.
 * ROLLBACK: remove the silwer-utm-forward.js script tag in layout/theme.liquid.
 */
(function () {
  'use strict';
  try {
    if (window.Shopify && window.Shopify.designMode) return;

    var UTM_KEY = /^utm_[a-z0-9_]+$/i;
    var SKIP_PATH = /^\/(cart|checkout|checkouts|account|apps|services|password|policies)(\/|$)/i;

    var keep = [];
    new URLSearchParams(window.location.search).forEach(function (value, key) {
      if (UTM_KEY.test(key) && value) keep.push([key, value]);
    });
    if (!keep.length) return;

    function decorate(link) {
      try {
        var raw = link.getAttribute('href');
        if (!raw || raw.charAt(0) === '#') return;
        if (/^(mailto|tel|sms|javascript):/i.test(raw)) return;
        if (link.hasAttribute('download')) return;

        var url = new URL(link.href, window.location.href);
        if (url.protocol !== 'https:' && url.protocol !== 'http:') return;
        if (url.host !== window.location.host) return;
        if (SKIP_PATH.test(url.pathname)) return;
        if (url.hash && url.pathname === window.location.pathname &&
            url.search === window.location.search) return;

        // A link that already carries its own utm_* tags is left alone, so
        // two campaigns' values are never mixed on one URL.
        var hasOwnUtm = false;
        url.searchParams.forEach(function (value, key) {
          if (UTM_KEY.test(key)) hasOwnUtm = true;
        });
        if (hasOwnUtm) return;

        var add = [];
        for (var i = 0; i < keep.length; i++) {
          add.push(encodeURIComponent(keep[i][0]) + '=' + encodeURIComponent(keep[i][1]));
        }

        // Append to the existing query string as-is, so the link's own
        // parameters keep their exact original encoding.
        var search = url.search ? url.search + '&' + add.join('&') : '?' + add.join('&');
        link.setAttribute('href', url.pathname + search + url.hash);
      } catch (e) {}
    }

    function onPointer(event) {
      var target = event.target;
      var link = target && target.closest ? target.closest('a[href]') : null;
      if (link) decorate(link);
    }

    document.addEventListener('click', onPointer, true);
    document.addEventListener('auxclick', onPointer, true);
    document.addEventListener('contextmenu', onPointer, true);
  } catch (e) {}
})();